/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargebeeResponse } from '../../models/chargebee-response';

export interface GetProfileSubscriptions$Params {

/**
 * ID of profile
 */
  id: number;
}

export function getProfileSubscriptions(http: HttpClient, rootUrl: string, params: GetProfileSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChargebeeResponse>>> {
  const rb = new RequestBuilder(rootUrl, getProfileSubscriptions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChargebeeResponse>>;
    })
  );
}

getProfileSubscriptions.PATH = '/rest/profile/{id}/purchase/subscriptions';
